module.exports = __webpack_public_path__ + "static/servicios-creados-para-ti-ipad-c91026cdb00d245ffbc105b0d15df7a7.jpg";